const state = () => ({
    response: {},
    user: {
        name: null,
        token: null,
        id: null
    },
    auth: {
        access_token: null,
        expires_in: null,
        'not-before-policy': 0,
        refresh_expires_in: 0,
        refresh_token: null,
        scope: '',
        session_state: '',
        token_type: ''
    },
    dadosUsuario: {},
    title: null,
    breadcrumbs: [],
    layoutHomeDoubt: true,
    itemsRandomizedStor: [],
    itemsOrganizedStor: [],
    onFullscreen: false,
    selectedItemMenu: '',
    srcImgemApiDefault: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAgCAYAAACcuBHKAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAINSURBVFhHzZZNywFRFMfPkMRGWdgoVr6FlI3yGWx8IkuWfAYLxZZCdkhKFkjYKEV593SuM2aMOzN3Xnr4Lcw5J937v+f+752Rjsfj43a7wTfwer3g9/vB8y0BiDy3h/1+mZ8QIR0OhwfFL+73+6tVboH77/F8rjkYDPJFXC4XJkTN6XRiTzSSHVCAz+ejTEFYRLPZhF6vx4SEQiHI5XLsaQUjEaaemM/n0Gq1Xp3Y7XYsdxNTEbPZjCIFXs0JpiLi8ThFCryaE0xFxGIxSKVSlAHzQjKZpMwdLJ0O9EMkEqGKNRwZUwaPplbAdruFYrEI9XqdKvYQ7gSPQqEAy+WSxdFoFPL5PITDYZZrcaUTWnD1sgAE41KpBNPplCrimIrgXd+DwQAajQZlCna3x1DEfr+H0WgEq9WKKs+JqtUqZXxQYLlcZv8VQVcETjyZTOB6vcJ6vWY3J1KpVIQGHw6HbHvUC9CDa8zFYvG23zIoqtvtUiZOJpOBbDZrzZjn85kihc1mY0sAgtuDL0E9hE4HeqPdblNmD15nZYREdDodJoSHJEkUvaNX52Eqot/vM2PKaAd/PD4sxdCr8zAUgT5AEWqsDI6IdERXhF0fiHZKja4IIx8YYbVTCFfEeDw29IGMFfMZwb2s8FKq1WqUOScQCEA6nYZEIkEVBd2v7f/E0avcTX5DBH7xfIvn3AB/jLEa7ylzLCIAAAAASUVORK5CYII=",
    registerTab: 0,
    apiDetailsTab: 0,
    termsPoliciesTypes: {
        TERMS: 'TERMS',
        POLICY: 'POLICY',
        COOKIES: 'COOKIES',
    },
    termsPoliciesData: [
        { type: 'TERMS', text: '<p> Carregendo TERMS ... </p>', creation: new Date() },
        { type: 'POLICY', text: '<p> Carregendo POLICY .... </p>', creation: new Date() },
        { type: 'COOKIES', text: '<p> Carregendo COOKIES ... </p>', creation: new Date() },
    ],
    termsPoliciesAccepetd: [
        { type: 'TERMS', accept: false },
        { type: 'POLICY', accept: false },
        { type: 'COOKIES', accept: false },
    ],
    noUseCookies: true,
    idUserWhoAccepted: true,
    countApproval: 0,
    profileSelected: "Usuário",
    menuGroupsActive: [],
    headerAdminType: null,
});
export default state;
